var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nodes"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 106",
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHollow);
export default __webpack_public_path__ + "static/media/circle-hollow.0724787c162fe54ba932fe52fcc68604.svg";
export { ForwardRef as ReactComponent };